import { CSSObject } from '@emotion/react'
import { Color, Spacing, Theme } from '@opallabs/gem'

export const buttonStyles = (theme: Theme) =>
  ({
    blockSize: 36,
    justifyContent: 'start',
    paddingInline: Spacing.S,
    width: '100%',

    '.lapidary-button-icon': {
      display: 'none',
    },
    '&:not(.hasValue ) .lapidary-button-text': {
      color: Color[theme]['Text/Secondary'],
    },
    '&[data-state="open"]': {
      borderColor: Color[theme]['Strokes/Primary-2'],
    },
    '&:hover:enabled:before': {
      backgroundColor: Color[theme]['Color/Surface/Surface-2'],
    },
  }) satisfies CSSObject
